export const checkIfAuthenticated = (state) => state.auth.isAuthenticated;
export const loginError = (state) => state.auth.errors;
export const getCurrentUser = (state) => state.auth.user;
export const getCurrentUserRole = (state) => state.auth.user.role;
export const getCurrentOverview = (state) => state.auth.overview;
export const getCurrentUserGroup = (state) => state.auth.user.group; 